import CurrencyFormat from 'react-currency-format';
import { LoadingSpinerArea } from '../../../../../../components';
import { AderenciaBigNumbersData } from '../../types';
import styles from './BigNumbersArea.module.scss';

type BigNumbersAreaProps = {
  data?: AderenciaBigNumbersData;
  isLoading?: boolean;
};

export const BigNumbersArea = ({ data, isLoading }: BigNumbersAreaProps) => {
  return (
    <div className={styles.container}>
      <LoadingSpinerArea area="aderencia-big-numbers" size="md" style={{ position: 'absolute' }} />
      <div className={styles['big-numbers-wrapper']}>
        <div className={styles['green-box']}>
          <div className={styles['numbers-wrapper']}>
            <p className={styles.numbers}>
              <CurrencyFormat
                fixedDecimalScale={true}
                value={data?.precoDentroDoRange || 0}
                displayType={'text'}
                decimalSeparator={','}
                thousandSeparator={'.'}
              />
            </p>
            <div className={styles['percentage-tag-green']}>
              <CurrencyFormat
                fixedDecimalScale={true}
                decimalScale={2}
                value={data?.percentualPrecoDentroDoRange || 0}
                displayType={'text'}
                suffix={'%'}
                decimalSeparator={','}
                thousandSeparator={'.'}
              />
            </div>
          </div>
          <p className={styles.title}>Preços dentro do range</p>
        </div>
        <div className={styles['red-box']}>
          <div className={styles['numbers-wrapper']}>
            <p className={styles.numbers}>
              <CurrencyFormat
                fixedDecimalScale={true}
                value={data?.precoForaDoRange || 0}
                displayType={'text'}
                decimalSeparator={','}
                thousandSeparator={'.'}
              />
            </p>
            <div className={styles['percentage-tag-red']}>
              <CurrencyFormat
                fixedDecimalScale={true}
                decimalScale={2}
                value={data?.percentualPrecoForaDoRange || 0}
                displayType={'text'}
                suffix={'%'}
                decimalSeparator={','}
                thousandSeparator={'.'}
              />
            </div>
          </div>
          <p className={styles.title}>Preços fora do range</p>
        </div>
        <div className={styles['red-box']}>
          <p className={styles.numbers}>
            <CurrencyFormat
              fixedDecimalScale={true}
              value={data?.produtoPrecoForaDoRange || 0}
              displayType={'text'}
              decimalSeparator={','}
              thousandSeparator={'.'}
            />
          </p>
          <p className={styles.title}>Produtos com preços fora do range</p>
        </div>
        <div className={styles['red-box']}>
          <p className={styles.numbers}>
            <CurrencyFormat
              fixedDecimalScale={true}
              value={data?.precoForaDoRangeRede || 0}
              displayType={'text'}
              decimalSeparator={','}
              thousandSeparator={'.'}
            />
          </p>
          <p className={styles.title}>Redes com preços fora do range</p>
        </div>
      </div>
    </div>
  );
};
